export const months = {
  'Enero': 1,
  'Febrero': 2,
  'Marzo': 3,
  'Abril': 4,
  'Mayo': 5,
  'Junio': 6,
  'Julio': 7,
  'Agosto': 8,
  'Septiembre': 9,
  'Octubre': 10,
  'Noviembre': 11,
  'Diciembre': 12,
};


export const montsSelect = [
  {'key': '0', 'value': 0, 'text': 'ENERO'},
  {'key': '1', 'value': 1, 'text': 'FEBRERO'},
  {'key': '2', 'value': 2, 'text': 'MARZO'},
  {'key': '3', 'value': 3, 'text': 'ABRIL'},
  {'key': '4', 'value': 4, 'text': 'MAYO'},
  {'key': '5', 'value': 5, 'text': 'JUNIO'},
  {'key': '6', 'value': 6, 'text': 'JULIO'},
  {'key': '7', 'value': 7, 'text': 'AGOSTO'},
  {'key': '8', 'value': 8, 'text': 'SEPTIEMBRE'},
  {'key': '9', 'value': 9, 'text': 'OCTUBRE'},
  {'key': '10', 'value': 10, 'text': 'NOVIEMBRE'},
  {'key': '11', 'value': 11, 'text': 'DICIEMBRE'},
];

export const monthsOptions = [
  {'key': '2', 'value': 1, 'text': 'ENERO'},
  {'key': '3', 'value': 2, 'text': 'FEBRERO'},
  {'key': '4', 'value': 3, 'text': 'MARZO'},
  {'key': '5', 'value': 4, 'text': 'ABRIL'},
  {'key': '6', 'value': 5, 'text': 'MAYO'},
  {'key': '7', 'value': 6, 'text': 'JUNIO'},
  {'key': '8', 'value': 7, 'text': 'JULIO'},
  {'key': '9', 'value': 8, 'text': 'AGOSTO'},
  {'key': '10', 'value': 9, 'text': 'SEPTIEMBRE'},
  {'key': '11', 'value': 10, 'text': 'OCTUBRE'},
  {'key': '12', 'value': 11, 'text': 'NOVIEMBRE'},
  {'key': '13', 'value': 12, 'text': 'DICIEMBRE'},
];
